import React from 'react';
import './Newsletter.css';

const Newsletter = (props) => {
  const { footnote } = props;
  return (
    <>
      <div id="omnisend-embedded-v2-63e269ade2d57f042eeb4892"></div>
      <p className="footnote">{footnote}</p>
    </>
  );
};

export default Newsletter;
